<template>
  <div class="channel-page">
    <!-- 顶部操作栏 -->
    <el-card class="tool-card" shadow="never">
      <div class="tool-row">
        <div class="tool-left">
          <span class="tool-title">来源渠道</span>
          <span class="tool-sub">线索来源渠道（抖音/QQ/微信等），录线索时下拉选择</span>
        </div>
        <el-button type="primary" icon="el-icon-plus" @click="openEdit(null)">新增渠道</el-button>
      </div>
    </el-card>

    <!-- 列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        empty-text="暂无渠道"
      >
        <el-table-column prop="name" label="渠道名称" min-width="200">
          <template slot-scope="{ row }">
            <div class="ch-name">
              <i class="el-icon-link ch-name-icon"></i>
              <span>{{ row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="weigh" min-width="100" align="center">
          <template slot-scope="{ row }">
            <span class="weigh-num">{{ row.weigh }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.status) === 1 ? 'success' : 'info'" size="small">
              {{ parseInt(row.status) === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="150">
          <template slot-scope="{ row }">
            <span class="time-text">{{ fmtDateTime(row.createtime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" size="small" class="del-btn" @click="doDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="editId ? '编辑来源渠道' : '新增来源渠道'" :visible.sync="editVisible" width="480px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
        <el-form-item label="渠道名称" prop="name">
          <el-input v-model="form.name" placeholder="如：抖音、微信、QQ、转介绍" :maxlength="50" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.weigh" :min="0" :max="9999" style="width: 200px" />
          <div class="form-hint">越小越靠前</div>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" active-text="启用" inactive-text="停用" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { channelManage, channelSave, channelDelete } from '@/api/base'

export default {
  name: 'ChannelList',
  data() {
    return {
      list: [],
      loading: false,
      editVisible: false,
      editId: 0,
      saving: false,
      form: { name: '', weigh: 0, status: true },
      rules: {
        name: [
          { required: true, message: '请填写渠道名称', trigger: 'blur' },
          { max: 50, message: '最多 50 字', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      channelManage()
        .then(data => { this.list = data.list || [] })
        .catch(() => { this.list = [] })
        .finally(() => { this.loading = false })
    },
    fmtDateTime(ts) {
      if (!ts) return '—'
      const d = new Date(parseInt(ts) * 1000)
      const p = n => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    },
    openEdit(row) {
      if (row) {
        this.editId = row.id
        this.form = {
          name: row.name,
          weigh: parseInt(row.weigh) || 0,
          status: parseInt(row.status) === 1
        }
      } else {
        this.editId = 0
        this.form = { name: '', weigh: 0, status: true }
      }
      this.editVisible = true
    },
    doSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        channelSave({
          id: this.editId,
          name: this.form.name.trim(),
          weigh: this.form.weigh,
          status: this.form.status ? 1 : 0
        })
          .then(() => {
            this.$message.success(this.editId ? '修改成功' : '新增成功')
            this.editVisible = false
            this.load()
          })
          .catch(() => {})
          .finally(() => { this.saving = false })
      })
    },
    doDelete(row) {
      this.$confirm(`确认删除来源渠道「${row.name}」？`, '删除渠道', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        channelDelete(row.id)
          .then(() => {
            this.$message.success('删除成功')
            this.load()
          })
          .catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.channel-page { padding: 0; }

.tool-card { margin-bottom: 14px; border-radius: 10px; border: 1px solid #E5E9F2; }
.tool-row { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; }
.tool-left { display: flex; align-items: baseline; gap: 12px; }
.tool-title { font-size: 15px; font-weight: 700; color: #18233C; }
.tool-sub { font-size: 12px; color: #8A94AD; }

.table-card { border-radius: 10px; border: 1px solid #E5E9F2; }

.ch-name { display: flex; align-items: center; gap: 8px; }
.ch-name-icon { font-size: 15px; color: #3668FC; background: #EDF3FE; border-radius: 6px; padding: 4px; }
.weigh-num { color: #5A6580; }
.time-text { color: #8A94AD; font-size: 12px; }
.del-btn { color: #E5484D; }
.form-hint { font-size: 11px; color: #B4BDCF; margin-top: 2px; }

::v-deep .el-button--primary { background: #3668FC; border-color: #3668FC; }
::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }
::v-deep .el-table__row:hover > td { background: #F5F8FF !important; }
::v-deep .el-dialog { border-radius: 12px; }
</style>